import { render, staticRenderFns } from "./ScoreClassList.vue?vue&type=template&id=28b0eb50&scoped=true&"
import script from "./ScoreClassList.vue?vue&type=script&lang=ts&"
export * from "./ScoreClassList.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreClassList.vue?vue&type=style&index=0&id=28b0eb50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b0eb50",
  null
  
)

export default component.exports